<script setup>
import ArrowRightIcon from '@/assets/icons/arrowRight.svg';
import CheckIcon from '@/assets/icons/check.svg';
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();
const user = computed(() => store.getters.user);

const selectedTemplateId = defineModel('selectedTemplateId', { type: String, default: '' });
const intoOrganization = defineModel('intoOrganization', { type: Boolean, default: true });

const emit = defineEmits(['submit', 'back']);

const { sortedTemplates = [] } = defineProps({
  sortedTemplates: Array,
});
</script>

<template>
  <div class="templates-list-section">
    <div class="title-container">
      <div class="title">{{ $t('popUp.createResume.template') }}</div>
    </div>
    <div class="templates-list">
      <div
        v-for="template in sortedTemplates"
        :key="template.id"
        class="template"
        :class="{ selected: template.id === selectedTemplateId }"
        :style="`background-image: url(${template.thumbnailUrl})`"
        @click="selectedTemplateId = template.id"
      >
        <div v-if="template.id === selectedTemplateId" class="check-container">
          <CheckIcon />
        </div>
      </div>
    </div>
    <div v-if="user.organization && user.organization.name" class="title-container-organization">
      <div class="title-container">
        <div class="title">{{ $t('popUp.createResume.spaceChoice') }}</div>
      </div>
      <div class="organization-container">
        <div class="checkbox-container" @click="intoOrganization = false">
          <div class="checkbox" :class="{ checked: !intoOrganization }"></div>
          <div class="title">
            {{ $t('popUp.createResume.personalGroup') }}
          </div>
        </div>
        <div class="checkbox-container" @click="intoOrganization = true">
          <div class="checkbox" :class="{ checked: intoOrganization }"></div>
          <div class="title">{{ user.organization.name }}</div>
        </div>
      </div>
    </div>
    <div class="import-resume-buttons">
      <button class="button-cancel" @click="emit('back')">
        <ArrowRightIcon /> <span>{{ $t('popUp.createResume.previousStep').toUpperCase() }}</span>
      </button>
      <button class="button-create" :class="{ disabled: !selectedTemplateId }" @click="emit('submit')">
        {{ $t('popUp.createResume.validate').toUpperCase() }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.templates-list-section {
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;

  .title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 12px 0;

    .title {
      color: #000000;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 4px;
    }

    .field {
      width: 100%;
      margin: 6px 0;
    }
  }

  .templates-list {
    display: flex;
    flex-wrap: wrap;
    overflow: scroll;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 1px;
    max-height: 50vh;
    gap: 22px;

    .template {
      box-sizing: border-box;
      width: 230px;
      height: 325px;
      border-radius: 4px;
      margin-bottom: 40px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      box-shadow:
        0 2px 8px -2px rgba(0, 0, 0, 0.1),
        0 4px 12px -4px rgba(0, 0, 0, 0.2);
      border: solid 1px white;
      cursor: pointer;
      &:hover {
        border-color: colors.$light-blue-color;
      }

      &.selected {
        border: 3px solid colors.$light-blue-color;
        position: relative;

        .check-container {
          position: absolute;
          right: 0;
          top: 0;
          height: 27px;
          width: 27px;
          border-radius: 0 0 0 2px;
          background-color: colors.$light-blue-color;
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            color: white;
          }
        }
      }
    }
  }

  .title-container-organization {
    margin-top: 2rem;
    .organization-container {
      display: flex;
      gap: 1.2rem;
      margin-top: 1rem;

      .checkbox-container {
        display: flex;
        gap: 0.5rem;
        cursor: pointer;
      }
    }
  }

  .import-resume-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > * {
      width: 14rem;
    }

    .button-cancel {
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      gap: 1rem;

      svg {
        rotate: 180deg;
        color: colors.$light-blue-color;
      }
    }

    .button-create {
      cursor: pointer;
    }
  }
}
</style>
